document.addEventListener("DOMContentLoaded", function () {
  let e = document.querySelector(".facets-wrapper select#SortBy"),
    t = document.querySelectorAll(
      ".facets-wrapper .sorting__options .sorting__option"
    ),
    c = document.querySelector(".facets-wrapper .sorting__options"),
    s = document.querySelector(".facets-wrapper .sorting__button");
  t.forEach((a) => {
    a.addEventListener("click", function () {
      a.classList.contains("active") ||
        ((function (e, t, c) {
          let s = e.dataset.value;
          t.forEach((e) => {
            e.classList.remove("active");
          }),
            e.classList.add("active"),
            c.querySelectorAll("option").forEach((e) => {
              e.removeAttribute("selected");
            }),
            c
              .querySelector('option[value="' + s + '"]')
              .setAttribute("selected", "selected"),
            c.dispatchEvent(new Event("change")),
            c.closest("form").dispatchEvent(new Event("input"));
        })(a, t, e),
        s.classList.remove("active"),
        c.classList.remove("active"));
    });
  }),
    s.addEventListener("click", function () {
      s.classList.contains("active")
        ? (s.classList.remove("active"), c.classList.remove("active"))
        : (s.classList.add("active"), c.classList.add("active"));
    });
});
